import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ModeloError } from '../../../../models/api.models';

@Component({
  selector: 'app-issues-error',
  templateUrl: './issues-error.component.html',
  styleUrls: ['./issues-error.component.scss'],
})
export class IssuesErrorComponent implements OnInit {

  @Input() isModal: boolean;
  @Input() errors: ModeloError;
  @Output() public exitEdMasivaErrorPressed  = new EventEmitter();

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() {}

  exit() {
    this.exitEdMasivaErrorPressed.emit();
    this.modalCtrl.dismiss();
  }

}
